import { INDICATOR_TYPES } from './chatIndicatorTypes';

export function shouldInsertIndicator(messages, type, matchKey, matchValue) {
  if (!matchValue) return false;
  const last = [...messages].reverse().find((m) => !INDICATOR_TYPES.has(m.type) || m.type === type);
  if (last?.type === type) {
    if (type === 'scope_change' && last.scope?.label === matchValue) return false;
    if (matchKey && last[matchKey] === matchValue) return false;
  }
  return true;
}

export function insertStoppedAfterMessage(messages, streamMsgId) {
  const updated = messages.map((m) =>
    m.id === streamMsgId ? { ...m, streaming: false, content: m.content || '' } : m
  );
  const idx = updated.findIndex((m) => m.id === streamMsgId);
  if (idx === -1) return updated;
  return [
    ...updated.slice(0, idx + 1),
    { id: `stopped-${Date.now()}`, type: 'response_stopped' },
    ...updated.slice(idx + 1),
  ];
}
